import { apiClient } from "../axiosConfig";
import { typeArchiveSalesFilters } from "./reducer";
import { typeRequestPagination } from "../system/constants";

export type typeArchiveSalesRequestFilters = {
  filters: {
    dateFilter?:
      | {
          startDate: string;
          endDate: string;
        }
      | {};
    receiptNumber?: string | null;
    salePublicId?: string | null;
  };
  pageFilter?: typeRequestPagination;
};

export const archiveSalesSearch = async (payload: {
  filters: typeArchiveSalesFilters;
  paginationRequest: typeRequestPagination;
}) => {
  const path = "/product/archive/sale/search";
  const config = {
    headers: {},
  };

  const data: typeArchiveSalesRequestFilters = {
    filters: {},
    pageFilter: payload.paginationRequest,
  };

  if (payload.filters.date) {
    data.filters.dateFilter! = payload.filters.date;
  }

  if (payload.filters?.receiptNumber) {
    data.filters.receiptNumber! = payload.filters.receiptNumber;
  }

  if (payload.filters?.salePublicId) {
    data.filters.salePublicId! = payload.filters.salePublicId;
  }

  try {
    return await apiClient.post(path, data, config);
  } catch (error) {
    console.log(error);
    return error.response;
  }
};
